/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：133
 */

"use strict"

export { IconWidgetImage as a }
export { Module_344$a as g }
export { a as l }
export { s as h }
export { Https__static$bcmcdn$com_coco_image_image_widget_default_image_v2$svg as i }
export { DataImage_gifBase64R0lGODlhAQABAIAAAAAAAP___yH5BAEAAAAALAAAAAABAAEAAAIBRAA7 as m }
export { DefaultImageWidgetTitle as b }
export { Image_jpegImage_pngImage_svgXmlImage_gifImage_bmp as f }
export { Image_svgXml as c }
export { Image_jpegImage_pngImage_bmp as d }
export { Image_jpegImage_pngImage_bmp1 as e }
export { m as k }
export { g as j }
import * as /* [auto-meaningful-name] */Module_344 from /* 344 */"./344"
var /* [auto-meaningful-name] */IconWidgetImage = "icon-widget-image"
var /* [auto-meaningful-name] */Module_344$a = Module_344.a
var a = 274
var s = 160
var /* [auto-meaningful-name] */Https__static$bcmcdn$com_coco_image_image_widget_default_image_v2$svg = "https://static.bcmcdn.com/coco/image/image_widget_default_image_v2.svg"
var /* [auto-meaningful-name] */DataImage_gifBase64R0lGODlhAQABAIAAAAAAAP___yH5BAEAAAAALAAAAAABAAEAAAIBRAA7 = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
var /* [auto-meaningful-name] */DefaultImageWidgetTitle = "defaultImageWidgetTitle"
var /* [auto-meaningful-name] */Image_jpegImage_pngImage_svgXmlImage_gifImage_bmp = "image/jpeg, image/png, image/svg+xml, image/gif, image/bmp"
var /* [auto-meaningful-name] */Image_svgXml = "image/svg+xml"
var /* [auto-meaningful-name] */Image_jpegImage_pngImage_bmp = "image/jpeg, image/png, image/bmp"
var /* [auto-meaningful-name] */Image_jpegImage_pngImage_bmp1 = "image/jpeg, image/png, image/bmp"
var m = false
var g = false
export default IconWidgetImage
